module.exports = __webpack_public_path__ + "img/logo_app@2x.e5c1a0a2.png";